import ToastService from "../service/toastService";
import ApiService from "../service/apiService";
import TypeLibelleService, {
  isCategorieDepense,
  isCategorieDon,
  isCategorieRecette,
  isDeviseEuro,
} from "../service/typeLibelleService";
import Multiselect from "vue-multiselect";
import DatePicker from "../components/DatePicker";
import CollapseCard from "../components/CollapseCard";
import SaisiePaginationTab from "../components/Saisie/SaisiePaginationTab";
import * as moment from "moment";

export default {
  name: "saisie",
  components: {
    Multiselect,
    DatePicker,
    CollapseCard,
    saisieTab: SaisiePaginationTab,
  },
  data() {
    return {
      //Object qui contient les libelle qui servent à comparer ("RECETTE", "DEPENSE", "DON"...)
      TypeLibelleService: TypeLibelleService,

      //Tableau d'objets pour le formulaire:
      categories: [],
      projets: [],
      modePaiements: [],
      simpleAdherents: [],
      devises: [],

      //Id des devise Euro, utilisé pour comparer et mettre la valeur par defaut
      deviseEuroId: "",
      categorieDonId: "",
      categorieDepenseId: "",

      //la saisie selectionnée
      selectedSaisie: {
        justificatifs: [],
      },

      selectedAdherent: {},
      //Nouveau fichier rajout"
      file: null,
      //Fichiers qu'il faut uploader
      filesToUpload: [],
      //Utiliser pour valider l'adhérent d'un don
      adherentError: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    isCategorieRecette,
    ajoutFile() {
      if (this.file) {
        let error = false;

        if (this.file.size > 2000000) {
          ToastService.displayErrorToast("Le fichier ne peut pas dépasser 2mo");
          error = true;
        }

        for (let justificatif of this.selectedSaisie.justificatifs) {
          if (!error && justificatif.fileName === this.file.name) {
            ToastService.displayErrorToast(
              "Deux fichiers ne peuvent pas avoir le même nom"
            );
            error = true;
            break;
          }
        }

        if (!error) {
          let justificatif = {
            fileName: this.file.name,
          };
          this.selectedSaisie.justificatifs.push(justificatif);
          this.filesToUpload.push(this.file);
        }
        this.file = null;
      }
    },
    deleteJustificatif(justificatif) {
      this.selectedSaisie.justificatifs =
        this.selectedSaisie.justificatifs.filter(function (value, index, arr) {
          return value.fileName != justificatif.fileName;
        });

      this.filesToUpload = this.filesToUpload.filter(function (
        value,
        index,
        arr
      ) {
        return value.name != justificatif.fileName;
      });
    },
    async uploadFiles(saisieId) {
      if (this.filesToUpload.length > 0) {
        this.filesToUpload.forEach(async (element) => {
          let formData = new FormData();
          let file = element;
          formData.append("file", file);
          ToastService.displayInfoToast("Upload du fichier " + file.name);
          await ApiService.justificatifs.uploadJustificatif(formData, saisieId);
        });

        this.$refs.saisieTab.refreshTable();
        this.filesToUpload = [];
      }
    },

    setAdherentError() {
      this.adherentError =
        this.selectedSaisie.categorieId == this.categorieDonId &&
        (!this.selectedAdherent.id || this.selectedAdherent === null);
    },

    /**
     * Action aprés la validation du formulaire de creation/modification d'utilisateur
     */
    async onSubmit() {
      //On vérifie les champs
      var result = await this.$validator.validateAll();
      this.setAdherentError();
      if (result && !this.adherentError) {
        this.adherentError = false;
        if (this.selectedSaisie.deviseId == this.deviseEuroId) {
          this.selectedSaisie.tauxChange = 1;
          this.selectedSaisie.montantEuro = this.selectedSaisie.montant;
        }
        if (this.selectedSaisie.categorieId == this.categorieDonId) {
          this.selectedSaisie.adherentId = "";
        }
        this.selectedSaisie.adherentId = this.selectedAdherent.id;

        ApiService.saisie.createUpdate(this.selectedSaisie).then((resp) => {
          if (resp.data) {
            let saisieId = resp.data.id;
            ToastService.displaySuccessToast("Saisie correctement enregistrée");
            this.uploadFiles(saisieId);
            this.resetForm();
            this.$refs.saisieTab.refreshTable();
          }
        });
      }
    },
    /**
     * Méthode appelé aprés la montage du composant
     */
    init() {
      this.findCategories();
      this.findProjets();
      this.findDevises();
      this.findSimpleAdherent();
      this.findModePaiement();
      this.resetForm();
    },

    /**
     * Récupére la liste de toutes les catégories du serveur
     */
    findCategories() {
      ApiService.categories.findCategories().then((resp) => {
        this.categories = resp.data;
        this.categories.forEach((element) => {
          if (isCategorieDon(element.libelle)) {
            this.categorieDonId = element.id;
          }

          if (isCategorieDepense(element.libelle)) {
            this.categorieDepenseId = element.id;
            this.selectedSaisie.categorieId = this.categorieDepenseId;
          }
        });
      });
    },
    /**
     * Récupére la liste de toutes les devises
     */
    async findDevises() {
      var resp = await ApiService.devises.findDevises();
      this.devises = resp.data;
      this.devises.forEach((element) => {
        if (isDeviseEuro(element.libelle)) {
          this.deviseEuroId = element.id;
          this.selectedSaisie.deviseId = this.deviseEuroId;
        }
      });
    },
    /**
     * Récupére la liste de tous les projets du serveur
     */
    findProjets() {
      ApiService.projet.findProjets().then((resp) => {
        this.projets = resp.data;
      });
    },
    /**
     * Récupére la liste de tous les projets du serveur
     */
    findSimpleAdherent() {
      ApiService.adherents.findSimpleAdherents().then((resp) => {
        this.simpleAdherents = resp.data;
      });
    },
    /**
     * Récupére la liste de tous les mode de paiement du serveur
     */
    findModePaiement() {
      ApiService.modePaiement.findModePaiement().then((resp) => {
        this.modePaiements = resp.data;
      });
    },
    /**
     * Envoi la requete de suppression d'une saisie, ferme la modal et retire la saisie selectionnée des saisies de la page
     */
    deleteSaisie(saisie) {
      ApiService.saisie.deleteSaisie(saisie.id).then((resp) => {
        ToastService.displaySuccessToast(resp.data.message);
        this.$refs.saisieTab.refreshTable();
      });
    },

    /**
     * Action lorsqu'on clique sur l'icone pour modifier une saisie
     */
    async onSelectEditSaisie(item) {
      //On vide d'abord l'existant
      this.resetForm();
      if (item.adherentId) {
        for (var adherent of this.simpleAdherents) {
          if (adherent.id === item.adherentId) {
            this.selectedAdherent = adherent;
            break;
          }
        }
      }
      this.selectedSaisie = Object.assign({}, item);
    },
    /**
     * Réinitialise le formulaire
     */
    resetForm() {
      this.selectedSaisie = {
        justificatifs: [],
        date: moment().format("DD/MM/YYYY"),
        deviseId: this.deviseEuroId,
        categorieId: this.categorieDepenseId,
      };
      this.selectedAdherent = {};

      this.$validator.reset();
      this.file = null;
      this.filesToUpload = [];
    },

    setMontants() {
      if (this.selectedSaisie.tauxChange && this.selectedSaisie.montant) {
        this.selectedSaisie.montantEuro =
          this.selectedSaisie.tauxChange * this.selectedSaisie.montant;
      }
      if (
        this.selectedSaisie.tauxChange != 0 &&
        this.selectedSaisie.montantEuro
      ) {
        this.selectedSaisie.montant = (
          this.selectedSaisie.montantEuro / this.selectedSaisie.tauxChange
        ).toFixed(2);
      }
    },
    setMontantEuro() {
      if (this.selectedSaisie.tauxChange && this.selectedSaisie.montant) {
        this.selectedSaisie.montantEuro = (
          this.selectedSaisie.tauxChange * this.selectedSaisie.montant
        ).toFixed(2);
      }
    },
    setMontant() {
      if (
        this.selectedSaisie.tauxChange != 0 &&
        this.selectedSaisie.montantEuro
      ) {
        this.selectedSaisie.montant = (
          this.selectedSaisie.montantEuro / this.selectedSaisie.tauxChange
        ).toFixed(2);
      }
    },
    setAdherentId() {
      if (this.selectedAdherent === null || !this.selectedAdherent.id) {
        this.selectedSaisie.adherentId = "";
        this.selectedAdherent = {};
      } else {
        this.selectedSaisie.adherentId = this.selectedAdherent.id;
      }

      this.setAdherentError();
    },
  },
  computed: {
    showDeviseInput() {
      return this.selectedSaisie.deviseId != this.deviseEuroId;
    },
  },
};
